<template>
    <svg width="200px" height="200px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 1.8V9" stroke="white" stroke-width="3.5" stroke-linecap="round"/>
        <path d="M17 5A9.3 9.3 0 1 1 7 5" stroke="white" stroke-width="3.5" stroke-linecap="round"/>
    </svg>
</template>

<script setup>
</script>
